import { PropsWithChildren } from 'react';
import { Bar, BarChart } from 'recharts';

import { CubeChartBaseProps } from '../CubeChart.types';
import { BaseChart } from '~/components/BaseChart/BaseChart';

export const CubeChartBar = <TData extends Record<string, any>>({
  resultSet,
}: PropsWithChildren<CubeChartBaseProps<TData>>) => {
  return (
    <BaseChart data={resultSet.chartPivot()} dataKey="x" chartComponent={BarChart} legend tooltip>
      {({ colors, className, size = 7 }) => (
        <>
          {resultSet.seriesNames().map((series, i) => (
            <Bar
              key={series.key}
              dataKey={series.key}
              name={series.title}
              className={className}
              fill={colors[i]}
              barSize={size}
              isAnimationActive={false}
              radius={[size / 2, size / 2, 0, 0] as any}
              legendType="circle"
            />
          ))}
        </>
      )}
    </BaseChart>
  );
};
